import { createContextKey } from '@opentelemetry/api';

export const experienceTypeKey: any = createContextKey('type');
